import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time',
  standalone: true,
})
export class TimePipe implements PipeTransform {
  transform(dateStr: string, offset: number = 6): string {
    if (!dateStr) return '';

    const date = new Date(dateStr);

    const hours = date.getUTCHours().toString().padStart(2, '0');
    const mins = date.getUTCMinutes().toString().padStart(2, '0');

    return `${hours}:${mins}`;
  }
}
